export enum DrpDetailsContentMinLengthsEnum {
  OPERATING_RATIO = 1,
  MONTHLY_REVENUE_POTENTIAL = 1,
  AVERAGE_MONTHLY_REVENUE = 1,
}
